export default function HowItWorks() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            How Itaobuy Spreadsheet Works
          </h2>
          <p className="mt-3 text-foreground-600 text-base max-w-lg mx-auto">
            Five simple steps to start sourcing smarter with the itaobuy spreadsheet system
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {[
            { step: '01', title: 'Browse Products', desc: 'Explore curated spreadsheet product listings organized by category and style.', icon: 'ri-search-line' },
            { step: '02', title: 'Select Items', desc: 'Pick products from the structured itaobuy spreadsheet list with clear pricing.', icon: 'ri-check-double-line' },
            { step: '03', title: 'Submit Order', desc: 'Place your order through the agent system with complete transparency.', icon: 'ri-send-plane-line' },
            { step: '04', title: 'Quality Check', desc: 'Receive QC images before shipping to ensure product meets expectations.', icon: 'ri-image-line' },
            { step: '05', title: 'Ship Globally', desc: 'Your order ships worldwide with reliable tracking and delivery options.', icon: 'ri-ship-line' },
          ].map((item) => (
            <div key={item.step} className="text-center group">
              <div className="w-16 h-16 mx-auto rounded-2xl bg-background-100 border border-background-200/70 flex items-center justify-center mb-4 group-hover:border-primary-300 group-hover:bg-primary-50 transition-all duration-300">
                <i className={`${item.icon} w-6 h-6 flex items-center justify-center text-foreground-700 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <span className="text-xs font-semibold text-primary-500 tracking-wider">{item.step}</span>
              <h3 className="mt-1 font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Start Sourcing Now
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}